import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TONES = {
  ok: "bg-emerald-50 text-emerald-800 border-emerald-200",
  warn: "bg-amber-50 text-amber-900 border-amber-300",
  off: "bg-slate-100 text-slate-600 border-slate-200",
};

function rows(s) {
  const e = s.account_email;
  const base = !e.configured ? ["off", "Not connected"]
    : e.last_result === "sent" ? ["ok", "Provider accepted last email"]
    : e.last_result === "rate_limited" ? ["warn", "Provider busy (rate limited), customers can resend"]
    : e.last_result === "failed" ? ["warn", "Unavailable, last email failed"]
    : ["warn", "Set up, not yet confirmed"];
  const email = [base[0], e.inbox_confirmed_on ? `${base[1]}. Inbox delivery confirmed by owner ${e.inbox_confirmed_on}` : e.last_result === "sent" ? `${base[1]} (inbox receipt not confirmed)` : base[1]];
  const tone = (st) => st === "connected" ? ["ok", "Connected, last request worked"] : st === "failed" ? ["warn", "Unavailable, last request failed"] : ["warn", "Set up, not yet tested"];
  const ai = tone(s.ai_form_guidance.status);
  const rem = s.email_reminders.status === "connected" ? ["ok", `Connected, last run ${new Date(s.email_reminders.last_run_at).toLocaleString()}`]
    : s.email_reminders.status === "failed" ? ["warn", "Last scheduled run failed"] : ["warn", "Set up, waiting for the first hourly run"];
  return [
    ["account-email", "Account emails", "Sign-up confirmation and password reset links.", ...email],
    ["file-storage", "Private file storage", "Where your uploaded documents are kept.", ...(s.file_storage.ready ? ["ok", "Connected"] : ["warn", "Unavailable"])],
    ["ai-form-help", "AI form help", "Explains one form question at a time. Never fills answers.", ...ai],
    ["ai-analysis", "AI document reading", "Plain-language reading of readable PDF and TXT uploads. Dates stay unconfirmed until you check them.", ...tone(s.ai_analysis.status)],
    ["email-reminders", "Automatic reminders", "Emails for confirmed dates only: upcoming reminders, overdue alerts and an optional daily summary.", ...rem],
    ["uspto-monitoring", "USPTO record monitoring", "EVR doesn't check USPTO records for you.", "off", "Not connected"],
    ["payments", "Payments and billing", "Subscriptions through Stripe checkout.", ...(s.payments.status === "live" ? ["ok", "Live"] : ["warn", "Test mode: no real charges"])],
  ];
}

export const IntegrationStatus = ({ compact = false }) => {
  const [status, setStatus] = useState(null);
  useEffect(() => { api.get("/system/status").then(({ data }) => setStatus(data)).catch(() => setStatus(false)); }, []);

  if (status === false) return <p data-testid="integration-status-error" className="text-sm text-red-700">Couldn't load service status.</p>;
  if (!status) return <div className="h-24 animate-pulse rounded-lg bg-slate-100" />;
  return (
    <ul data-testid="integration-status-panel" className="divide-y rounded-lg border bg-white">
      {rows(status).map(([key, label, help, tone, text]) => (
        <li key={key} className="flex items-center justify-between gap-3 px-4 py-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-navy">{label}</p>
            {!compact && <p className="text-xs text-slate-500">{help}</p>}
          </div>
          <span data-testid={`integration-status-${key}`} className={`max-w-[55%] rounded-2xl border px-2.5 py-0.5 text-right text-xs font-medium leading-snug ${TONES[tone]}`}>{text}</span>
        </li>
      ))}
    </ul>
  );
};
